import React from 'react';

import { useInstanceCallback } from '@/scenarios/legacy-player/hooks/useInstanceCallback';
import { AudioTrack, TextTrack } from '@/scenarios/legacy-player/types/instance';
import { useTrailerAudio } from '@/scenarios/legacy-player/components/trailer-player/hooks/use-trailer-audio';

import { AudioSettingPopupButtonContainer } from '../../../feature-player/ui/skin/audio-setting-popup-button/container';
import { BaseControlName } from '../../../feature-player/types/controls';
import { useTrailerSubtitles } from '../../hooks/use-trailer-subtitles';

interface Props {
    contentId: string;
    onSubtitleSizeSettingsClick: () => void;
}

export const TrailerAudioSettingsPopup = ({ contentId, onSubtitleSizeSettingsClick }: Props) => {
    const audio = useTrailerAudio(contentId);
    const subtitles = useTrailerSubtitles(contentId);

    const onAudioLangChange = useInstanceCallback((instance, newTrack: AudioTrack) => {
        if (newTrack && instance) {
            instance.setAudioTrack(newTrack);
        }
    }, []);

    const onSubtitlesLangChange = useInstanceCallback((instance, newTrack: TextTrack) => {
        if (newTrack && instance) {
            instance.setTextTrack(newTrack);
        }
    }, []);

    return (
        <AudioSettingPopupButtonContainer
            name={BaseControlName.AUDIO_SUBS_LIST}
            audioTracks={audio}
            subtitles={subtitles}
            onSelectAudioTrack={onAudioLangChange}
            onSelectTextTrack={onSubtitlesLangChange}
            onSubtitleSizeSettingsClick={onSubtitleSizeSettingsClick}
            contentId={contentId}
        />
    );
};
